<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content"
                 :class="{
                    'QIAOHU_ROOM_DETAIL_CSS': stateroomDetail.isQiaohu,
                    'STARRYSKY_ROOM_DETAIL_CSS': stateroomDetail.isStarrySky,
                    'PCP_GIFT_THEME_ROOM_DETAIL_CSS': stateroomDetail.isPcpGiftTheme,
                    'CUSTOM_THEME_ROOM_DETAIL_CSS': stateroomDetail.isCustomTheme
                 }">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img :src="`${imgUrl}/cruiseDetail/suite/suite-modal-close.png`">
                </div>
                <div class="modal-body">
                    <div class="inner">
                        <div class="inner-top">
                            <div class="left_box">
                                <img class="banner-detail-logo" :src="`${imgUrl}/cruiseDetail/suite/suite-header-logo.png`"/>
                                <BannerDetail v-if="stateroomImages.length > 0"
                                    :banners="stateroomImages"
                                    isSuite
                                    :bannerSuffix="getBannerSuffix+'_suite'"
                                    style="height: 487px;"
                                />
                            </div>
                            <div class="inner-blank"></div>
                        </div>
                        <div class="inner-bottom">
                            <div class="room_detail" style="padding: 0 30px 35px">
                                <div class="room_tag">
                                  <img
                                      class="qiaohu_tag"
                                      v-if="stateroomDetail.isQiaohu"
                                      src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png"
                                  />
                                  <img
                                      class="starry_sky_tag"
                                      v-if="stateroomDetail.isStarrySky"
                                      src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png"
                                  />
                                  <div v-else-if="stateroomDetail.isPcpGiftTheme">
                                    <img class="pcp_gift_theme_tag" :src="stateroomDetail.personalizedStateroomInfo?.roomIconImage" />
                                  </div>
                                  <div v-else-if="stateroomDetail.isCustomTheme">
                                    <img class="custom_theme_tag" :src="stateroomDetail.personalizedStateroomInfo?.roomIconImage" />
                                  </div>
                                  <img class="suite-tag"
                                       v-if="stateroomDetail.stateroomType === 'DELUXE' && stateroomDetail.stateroomTag > 0"
                                       :src="GlobalData.suiteImgValue[stateroomDetail.stateroomTag]"/>
<!--                                  <img class="suite-tag"-->
<!--                                       v-if="stateroomDetail.stateroomTag && stateroomDetail.stateroomTag.indexOf('银钻')>=0"-->
<!--                                       :src="`${imgUrl}/cruiseDetail/suite/suite-sea.jpg`"/>-->
<!--                                  <img class="suite-tag"-->
<!--                                       v-else-if="stateroomDetail.stateroomTag && stateroomDetail.stateroomTag.indexOf('金钻')>=0"-->
<!--                                       :src="`${imgUrl}/cruiseDetail/suite/suite-sky.jpg`"/>-->
<!--                                  <img class="suite-tag"-->
<!--                                       v-else-if="stateroomDetail.stateroomTag && stateroomDetail.stateroomTag.indexOf('星钻')>=0"-->
<!--                                       :src="`${imgUrl}/cruiseDetail/suite/suite-star.jpg`"/>-->
                                </div>
                                <div class="room_title">
                                    {{getStateroomName}}
                                </div>
                                <div class="room_info">
                                  <span>舱房：{{stateroomDetail.stateroomArea}}</span>
                                  <span>阳台：{{stateroomBalconyArea}}</span>
                                  <span v-if="stateroomDetail.stateroomFloor&&stateroomDetail.stateroomFloor.length>0">楼层：{{stateroomDetail.stateroomFloor}}</span>
                                </div>
<!--                                <DeviceFeatureTags v-if="stateroomDetail.deviceFeatureTags"-->
<!--                                                    :viewNum="stateroomDetail.deviceFeatureTags.length"-->
<!--                                                    :tags="stateroomDetail.deviceFeatureTags"></DeviceFeatureTags>-->
                                <div @click="onShowQiaohuPopup" v-if="stateroomDetail.isQiaohu">
                                    <img class="qiaohu_tag" src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png">
                                </div>
                                <div @click="onShowStarrySkyPopup" v-if="stateroomDetail.isStarrySky">
                                  <img class="qiaohu_tag" src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png">
                                </div>
                                <div @click="onShowPcpGiftThemePopup(stateroomDetail.personalizedStateroomInfo)"
                                     v-else-if="stateroomDetail.isPcpGiftTheme">
                                  <img class="pcp_gift_theme_tag" :src="stateroomDetail.personalizedStateroomInfo?.roomIconImage" />
                                </div>
                                <div @click="onShowCustomThemePopup(stateroomDetail.personalizedStateroomInfo)"
                                     v-else-if="stateroomDetail.isCustomTheme">
                                  <img class="custom_theme_tag" :src="stateroomDetail.personalizedStateroomInfo?.roomIconImage" />
                                </div>
                                <div class="room_price">
                                   <div>
                                       <span v-if="stateroomDetail.stateroomPrice>0&&isShowPrice">
                                        <span class="title">{{stateroomDetail.stateroomPriceType}}（含税）</span>
                                        <em class="price">￥<em class="number">{{stateroomDetail.stateroomPrice.toFixed(0)}}</em>/人起</em>
                                    </span>

                                    <NrpTag
                                        :isNrp="stateroomDetail.isNrp"
                                        :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
                                        :direction="nrpTagDirection"
                                        :customClasses="nrpTagClasses"
                                        :showRow="showRow"
                                    />
                                  </div>
                                </div>

                                <div v-if="stateroomDetail.roomSummaryList && stateroomDetail.roomSummaryList.length>0 && stateroomDetail.suiteType > 0"
                                  class="summ-box"
                                  @click="onShowStateroomSuitePopup(stateroomDetail.suiteImageUrl)"
                                  >
                                  <div class="summ-box-list" style="flex-wrap: wrap;">
                                    <div class="summ-box-item"
                                    :class="[stateroomDetail.suiteType == 1 ? 'tab-room-box-see':stateroomDetail.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
                                    v-for="item in stateroomDetail.roomSummaryList" :key="item">{{ item }}</div>
                                  </div>
                                  <div class="summ-box-list"
                                    :class="[stateroomDetail.suiteType == 1 ? 'tab-room-box-see':stateroomDetail.suiteType == 2 ? 'tab-room-box-sky':'tab-room-box-star']"
                                  >
                                    {{stateroomDetail.suiteRightsCount}}项 
                                    <img class="summ-box-item-img" v-if="stateroomDetail.suiteType == 1" :src="currImgUrl+'see.png'" alt="">
                                    <img class="summ-box-item-img" v-else-if="stateroomDetail.suiteType == 2" :src="currImgUrl+'sky.png'" alt="">
                                    <img class="summ-box-item-img" v-else-if="stateroomDetail.suiteType == 3" :src="currImgUrl+'star.png'" alt="">
                                  </div>
                                </div>

                                <div class="qiaohu_content" v-if="stateroomDetail.isQiaohu">
                                  <div class="qiaohu_title_css">
                                    主题房内到处可以找到巧虎的可爱身影，床罩、沙发靠垫、壁画，阳台门以及墙上都有巧虎元素的装饰。
                                  </div>
                                  <div class="qiaohu_title_css">
                                    <div class="title_css">预订巧虎主题房可享福利：</div>
                                    <div>
                                      1. 巧虎神秘萌礼<br/>
                                      2. 和巧虎一起早餐（全程一次）<br/>
                                      *巧虎人偶仅在指定活动区域与宾客进行互动，互动形式以现场实际安排为准。
                                    </div>
                                  </div>
                                  <div class="qiaohu_title_css">
                                    <div class="title_css">航程中可以与巧虎一起参加哪些活动？</div>

                                    <div>
                                      1. 巧虎欢迎仪式<br>
                                      2. 与巧虎小船长互动拍照留念<br>
                                      3. 在海上历奇中心和巧虎一起玩耍<br>
                                    </div>

                                  </div>

                                    <div class="qiaohu_title_css">
                                        <div class="title_css">巧虎主题房预订须知：</div>
                                        <div>
                                            巧虎主题房不可与同期其他促销活动及优惠券同享，包括但不限于品牌特惠及限时闪惠活动、招商银行折扣券、抽奖券等优惠促销活动，不可与皇家指定渠道专属优惠同享。
                                        </div>
                                    </div>
                                </div>
                                <div class="starry_sky_content" v-if="stateroomDetail.isStarrySky">
                                  <div class="starry_sky_title_css">
                                    <div class="title_css" style="margin-top: 0">全新星空主题房介绍：</div>
                                    <div>全新星空主题房，体验星辰大海的梦幻之旅。独特的太空主题装饰和星空投影灯，让您和家人仿佛置身于浩瀚星空下，感受宇宙的浩瀚与神秘。</div>
                                  </div>
                                  <div class="starry_sky_title_css">
                                    <div class="title_css">星空房内饰含：</div>
                                    <div>沙发抱枕（含枕芯）、星空床罩 (折叠在柜子里)、星空投影灯、创意月球灯、星空桌垫、太空人摆件、墙面磁铁、温馨提示卡、星空投影灯使用说明</div>
                                  </div>
                                  <div class="starry_sky_title_css">
                                    <div class="title_css">房间须知：</div>
                                    <div>
                                      1. 入住星空房的客人，将会被预收取每舱房100美金作为星空房主题装饰和装置的押金，于登轮时计入船上消费账单。在您离开光谱号时，请不要带走房间内的装饰和装置。若未发生舱房主题装饰损坏或者遗失等情况，上述押金将原路退回。<br>
                                      2. 房间内设置星空投影灯，客人可自行调节投影图片。<br>
                                      3. 房间图片为效果图，仅供参考，以实际入住为准。<br>
                                      4. 床罩可替换为星空床罩，如需要请联系客房服务生布置。
                                    </div>
                                  </div>
                                </div>

                                <div class="line-gap"></div>
                                
                                <div class="detail-main-module" style="padding-top: 20px;">
                                  <div class="detail-main-module-inner">
                                    <div class="detail-module">
                                      <div class="title-main">
                                        <h3 class="title">舱房描述</h3>
                                      </div>
                                      <div class="content" v-html="stateroomDetail.stateroomDescription">
                                      </div>

                                      <div class="room_tips room_tips_line">
                                        <div>
                                          注：房间图片仅供参考，以实际入住为准。
                                        </div>
                                        <div class="room_tips_item">
                                          *房间图片仅供参考，以实际入住为准
                                        </div>
                                        <div>
                                          *房间价格以实时为准
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                                <div v-if="ruleDescription" class="" v-html="ruleDescription"></div>
                                <div 
                                     class="detail-main-module" style="padding-top: 20px;">
                                  <div class="detail-module no-bc" style="padding-top: 0">
                                    <div class="title-main">
                                      <h3 class="title">舱房详情</h3>
                                      <div v-if="isFacilities" class="feature"><span>●</span>该设施为本房型特色设施</div>
                                    </div>
                                    <div class="content">
                                      <div class="icon-model">
                                        <div class="icon-type-title">入住人数</div>
                                        <div class="icon-item col-3">
                                          <img class="icon" style="width:16px;height:16px" :src="currImgUrl+'peopleCount.png'"  />
                                          <div class="name">可入住 {{stateroomDetail.guestNumber}} 人（6月龄以上需计入人数）</div>
                                        </div>
                                        <div class="common-clr"></div>
                                      </div>
                                      <template v-if="stateroomDetail.deviceGroupTags && stateroomDetail.deviceGroupTags.length && showRow == false">

                                      <DeviceGroupTags v-for="(item,index) in stateroomDetail.deviceGroupTags" :key="index"
                                                       :category="item.name"
                                                       :index="index"
                                                       :length="stateroomDetail.deviceGroupTags.length"
                                                       :facilities="item.deviceTags"></DeviceGroupTags>
                                        </template>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="inner-bottom-img">
                          <img :src="`${imgUrl}/cruiseDetail/suite/suite-layer-footer.png`"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bookingHelper from '@/utilities/bookingHelper'
// const BannerDetail = () => import('@/components/BannerDetailSuite.vue')
const BannerDetail = () => import('@/components/BannerDetail.vue')

const NrpTag = () => import('@/components/Booking/NrpTag.vue')
// const DeviceFeatureTags = ()=> import("@/components/Cruise/CruiseDetail/DeviceFeatureTags.vue");
const DeviceGroupTags = () => import('@/components/Cruise/CruiseDetail/DeviceGroupTags.vue')
export default {
    name: "StateroomDetailSuite",
    components: {
        BannerDetail,
        NrpTag,
        // DeviceFeatureTags,
        DeviceGroupTags
    },
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        stateroomDetail: {
            type: Object,
            default () {
                return {
                    stateroomImages: [],
                    stateroomImageDataList:[],
                    stateroomName: '',
                    stateroomCategory: '',
                    stateroomPriceType: '',
                    stateroomPrice: 0,
                    stateroomCapacity: '',
                    stateroomArea: '',
                    stateroomBalcony: '',
                    stateroomFloor: '',
                    isQiaohu: false,
                    isStarrySky: false,
                    isNrp: false,
                    stateroomDescription: '',
                    stateroomNrpTitle: '',
                    stateroomNrpText: '',
                    suiteMobileImageUrl: '',
                    stateroomShelter: '',
                    guestNumber: 0
                }
            }
        },
        isFortyEightHoursNrpCruise: {
            type: Boolean
        },
        showQiaohuPopup: {
            type: Function
        },
        showStarrySkyPopup: {
            type: Function
        },
        showPcpGiftThemePopup: {
          type: Function
        },
        showCustomThemePopup: {
          type: Function
        },
        isShowPrice: {
            type: Boolean,
            default () {
                return false
            }
        },
        showStateroomSuitePopup: {
          type: Function,
        },
        ruleDescription: {
            type: String
        },
        
        showRow: {
          type: Boolean,
          default: false,
        },
    },
    data () {
        return {
            isShowModal: false,
            currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',

            imgUrl: process.env.VUE_APP_IMG_URL
        }
    },
    methods: {
      onShowStateroomSuitePopup(suiteImage) {
          console.log(suiteImage)
          this.showStateroomSuitePopup(suiteImage);
        },
        stateroomImageChange(slide) {
            if (slide == 'prev') {
                this.bannerSwiper.slidePrev()
            } else {
                this.bannerSwiper.slideNext()
            }
        },
        onModalClose () {
            this.isShowModal = false
            this.pauseAllVideo();
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
        pauseAllVideo() {
          // 获取所有bannerSwiper-pic元素
          const picElements = document.querySelectorAll('.bannerSwiper-pic')

          // 遍历每个pic元素，查找video标签并暂停播放
          picElements.forEach(picElement => {
            const videoElements = picElement.querySelectorAll('video')
            videoElements.forEach(video => {
              if (!video.paused) {
                video.currentTime = 0
                video.pause()
              }
            })
          })
        },
      onShowQiaohuPopup() {
        this.showQiaohuPopup();
      },
      onShowStarrySkyPopup() {
        this.showStarrySkyPopup();
      },
      onShowPcpGiftThemePopup(val) {
        this.showPcpGiftThemePopup(val);
      },
      onShowCustomThemePopup(val) {
        this.showCustomThemePopup(val);
      }
    },
    computed: {
        stateroomBalconyArea () {
            const stateroom = this.stateroomDetail
            if (!stateroom.stateroomBalcony || stateroom.stateroomBalcony == '' || stateroom.stateroomBalcony == '无') {
                return '无阳台'
            }
            if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
                return "(" + stateroom.stateroomShelter + "视线遮挡) " + stateroom.stateroomBalcony
            }
            return stateroom.stateroomBalcony
        },
        getStateroomName() {
            const stateroom = this.stateroomDetail
            let name = stateroom.stateroomName + ''
            const shelter = stateroom.stateroomShelter
            if (shelter && shelter.length > 0 && name && name.indexOf('遮挡') < 0) {
                name += "（有遮挡）"
            }
            let code = stateroom.stateroomCategory
            if (code && code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            name = `${name}_${code}`
            if (stateroom.guestNumber && stateroom.guestNumber > 0) {
                let guestCountText = bookingHelper.getStateroomGuestNumber(stateroom.guestNumber)
                if (guestCountText.length > 0) {
                    name += `(${guestCountText})`
                }
            }
            return name
        },
        stateroomImages() {
            let images = []
            if (this.stateroomDetail && this.stateroomDetail.stateroomImageDataList) {
                this.stateroomDetail.stateroomImageDataList.forEach(image => {
                    image.image = image.imageUrl
                    images.push(
                        image
                    )
                })
            }
            // console.log(images,'imagesimages')
            return images
        },
        nrpTagClasses () {
            let nrpTagClasses = ['stateroomDetailNrp']
            if (this.isFortyEightHoursNrpCruise) {
                nrpTagClasses.push('fortyEightHoursNrp')
            }
            return nrpTagClasses
        },
        nrpTagDirection () {
            if (this.isFortyEightHoursNrpCruise) {
                return 'bottom'
            }
            return 'right'
        },
        isFacilities() {
          let isFeature = false;
          if(this.stateroomDetail && this.stateroomDetail.deviceGroupTags && this.stateroomDetail.deviceGroupTags.length){
            for(let i = 0; i < this.stateroomDetail.deviceGroupTags.length; i++) {
              let deviceGroupTags = this.stateroomDetail.deviceGroupTags[i];
              for(let j = 0; j < deviceGroupTags.deviceTags.length; j++) {
                let deviceTags = deviceGroupTags.deviceTags[j];
                if(deviceTags.isFeature) {
                  isFeature = true;
                  break;
                }
              }
              if(isFeature) break;
            }
          }
          return isFeature;
        },
        getBannerSuffix () {
          const stateroom = this.stateroomDetail;
          return `${stateroom.stateroomCategory}_${stateroom.guestNumber}_${stateroom.roomListIndex}_${stateroom.stateroomIndex || ''}`;
        }
    },
    watch: {
      stateroomDetail() {},
      isShow (newValue) {
          setTimeout(()=> {
              this.isShowModal = newValue
          }, 100)
      }
    }
}
</script>

<style lang="less" scoped>
.common-modal-close {
  top: 0;
  right: -40px;
  width: 40px;
}
.modal {
  overflow-y: auto;
}
.modal-dialog {
    top: 50px;
    width: 944px;

}
.modal.active {
    display: block;
}
.modal-content {
  background-color: #FAFAFA;
  border-radius: 0;
  border: none;
}
.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-body {
    position: relative;
    padding: 0;
    border-radius: 0;
    background-color: #322B23;
    //background-color: #FAFAFA;
    .inner {
      //overflow: hidden;
      padding: 0;
      position: relative;
      margin-bottom: 150px;
      & .inner-top{
        position: relative;
        height: 510px;
        width: 100%;

        & .banner-detail-logo {
          width: 944px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 999;
        }
      }
      & .inner-blank {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 944px;
        height: 23px;
        z-index: 99;
        background-color: #FFFFFF;
      }
      & .inner-bottom{
        width: 944px;
        margin: 0 auto;
        z-index: 99;
        background-color: #FFFFFF;
      }
      & .inner-bottom-img {
        position: absolute;
        bottom: -49px;
        left: 0;
        display: block;
        width: 944px;
        margin: 0 auto;
        background-color: #FFFFFF;
      }
    }
    .room_detail {
        position: relative;
        background-color: #FFFFFF;
        .room_tag {
          position: absolute;
          top: 0;
          right: 30px;
          & > img {
            height: 45px;
            width: auto;
          }
        }
        .room_title {
            font-size: 28px;
            color: #282b2c;
            font-weight: bold;
            padding-right: 40px;
        }
        .room_tips {
          margin-top: 25px;
          color: #a6aeb1;
        }
        .room_tips_line{
          box-sizing: border-box;
          padding-bottom: 20px;
          border-bottom: 1px solid #f1f1f1;
        }
        .room_tips_item{
          line-height: 1.8;
        }
        .line-gap{
          box-sizing: border-box;
          padding-bottom: 20px;
          border-bottom: 6px solid #f1f1f1;
        }
        .qiaohu_tag {
          cursor: pointer;
          margin-right: 10px;
          margin-top: 10px;
        }
        .starry_sky_tag {
          cursor: pointer;
          margin-right: 10px;
          margin-top: 10px;
        }
        .pcp_gift_theme_tag {
          cursor: pointer;
          margin-right: 10px;
          margin-top: 10px;
          height: 28px;
        }
        .custom_theme_tag {
          cursor: pointer;
          margin-right: 10px;
          margin-top: 10px;
          height: 28px;
        }
        .room_price {
            width: 100%;
            color: #282b2c;
            margin-top: 5px;
            // padding-right: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            .title {
              font-weight: bold;
            }
            .price {
                color: #ff3022;
                font-weight: bold;
                font-style: normal;
                margin-right: 20px;
                & .number {
                  font-size: 24px;
                  font-style: normal;
                }
            }
            a {
                text-decoration: underline;
            }
        }
        .qiaohu_content {
            border-top: 1px solid #ccc;
            border-bottom: 1px solid #cccc;
            padding-top: 10px;
            margin-bottom: 10px;
            .qiaohu_title_css {
                margin-bottom: 10px;
            }
        }
        .starry_sky_content {
          border-top: 1px solid #ccc;
          border-bottom: 1px solid #cccc;
          padding-top: 10px;
          padding-bottom: 25px;
          .starry_sky_title_css {
            margin-bottom: 10px;
          }
          .starry_sky_list {
            list-style: disc;
            padding-left: 15px;
            & li {
              list-style: disc;
            }
          }
        }
        .title_css {
            font-weight: 600;
            margin-bottom: 1px;
            margin-top: 25px;
            font-size: 20px;
            color: #282b2c;
        }
        .room_info {
            margin-top: 10px;
            padding-right: 40px;
            span {
                position: relative;
                display: inline-block;
                margin-right: 28px;
                color: #a6aeb1;
            }
            span::after {
                content: '';
                position: absolute;
                width: 2px;
                height: 12px;
                display: block;
                background: #cacaca;
                top: 4px;
                right: -14px;
            }
            span:last-child:after {
                display: none;
            }
        }
        .room_detail {
            margin-top: -1px;
            line-height: 1.6;
            margin-bottom: 10px;
        }
    }
}

.ship_tags {
  margin-top: 8px;
  & .tag {
    display: inline-block;
    margin-right: 25px;

    & > img {
      display: inline-block;
      height: 14px;
      margin-right: 5px;
    }
    & > div {
      line-height: 14px;
      font-size: 13px;
      color: #282b2c;
      display: inline-block;
    }
  }
}

.detail-main-module {
  padding-top: 40px;
  padding-bottom: 10px;
  & .detail-main-module-inner {
    //padding-bottom: 20px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  & .detail-module {
    //padding: 0 0 25px;
    //border-bottom: 1px solid #eeeeee;
    &.no-bc {
      border: none;
    }
    & > .title-main {
      position: relative;
      & > .title {
        position: relative;
        padding: 0 0 0 13px;
        margin: 0;
        font-size: 22px;
        font-weight: bold;
        color: #333333;
        &:before {
          content: "";
          display: block;
          width: 5px;
          height: 20px;
          position: absolute;
          top: 2px;
          left: 0;
          background-color: #0074BA;
        }
      }
      & > .feature {
        position: absolute;
        top: 4px;
        right: 0;
        font-size: 12px;
        color: #a6aeb1;
        & > span {
          position: absolute;
          left: -15px;
          top: -1px;
          font-size: 12px;
          margin-left: 4px;
          color: #0173BC;
        }
      }
    }
    & .content {
      padding: 20px 0 0 0;
      color: #a6aeb1;
    }
    & .room-devices {
      overflow: hidden;
      & > li {
        width: 32.33%;
        margin-right: 1%;
        float: left;
        & .title {
          font-size: 16px;
          font-weight: bold;
          margin: 10px 0 15px;
          color: #333333;
        }
      }
    }
  }
}

.QIAOHU_ROOM_DETAIL_CSS {
  border: 3px solid #ffe100;
  background: #ffffff;
}
.STARRYSKY_ROOM_DETAIL_CSS {
  border: 3px solid #ffe100;
  background: #ffffff;
}
.PCP_GIFT_THEME_ROOM_DETAIL_CSS {
  border: 3px solid #ffe100;
}
.CUSTOM_THEME_ROOM_DETAIL_CSS {
  border: 3px solid #ffe100;
}

.summ-box{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-top: 10px;
}
.summ-box-list{
  display: flex;
  align-items: center;
}
.summ-box-item{
  margin-right: 8px;
  border: 1px solid;
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 4px;
}
.summ-box-item-img{
  width: 14px;
  height: 14px;
}
.tab-room-box-see{
  color: #43797D;
  border-color: #43797D;
}
.tab-room-box-sky{
  color: #3D60AF;
  border-color: #3D60AF;
}
.tab-room-box-star{
  color: #8B3C63;
  border-color: #8B3C63;
}

.icon-model {
  margin-top: 20px;
  padding-bottom: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #f1f1f1;

  &:first-child {
    margin-top: 0;
  }
}
.icon-type-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333333;
}
.icon-item {
  padding: 6px 0;
  overflow: hidden;
  font-size: 14px;
  color: #747d80;
  &.col-3 {
    float: left;
    width: 30%;
    margin-right: 3.33%;
  }
  & .icon {
    float: left;
    display: block;
    height: 14px;
    width: 14px;
    margin-right: 8px;
  }
  & .name {
    overflow: hidden;
    margin-top: -2px;
    line-height: 18px;
  }
  & .is-characteristic {
    font-size: 12px;
    margin-left: 4px;
    color: #0173BC;
  }
}

</style>
